export default __webpack_public_path__ + "static/media/circle-one.82af642c.svg";